import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

import { catchError } from 'rxjs/operators';
import { forkJoin, Observable, tap, throwError } from 'rxjs';

import { FormPatientCardioService } from '@services/form/form-patient-cardio.service';
import { CompaniesService } from '@app/companies/services/companies.service';
import { PatientService } from '@services/patient';
import { CompanyService } from '@app/company/services/company.service';
import { AuthService } from '../security';
import { ErrorFormService } from './error-form.service';
import { FormatFormService } from './format-form.service';

@Injectable({ providedIn: 'root' })
export class InclusionCardioService {
    patient;
    comment = '';

    constructor(
        private http: HttpClient,
        private patientService: PatientService,
        private formatService: FormatFormService,
        private formPatientCardioService: FormPatientCardioService,
        private companiesService: CompaniesService,
        private companyService: CompanyService,
        private errorService: ErrorFormService,
        private authService: AuthService,
    ) {
        this.initInclusionFast();
    }

    initInclusionFast(): Observable<any> {
        this.errorService.resetErrors();
        this.comment = '';
        this.patient = {
            identityDoc: undefined,
            absenceContact: {},
            idel: { has: false },
            housemaid: { has: false },
            phones: {},
            signedConsent: true,
            medicalData: {},
            inclusion: {
                type: 'commonLaw',
                enableScale: true,
                enableTensio: true,
                billingPackage: 'tvb',
            },
            address: {},
            spokenLanguage: ['fr'],
            prescriber: {},
            toComplete: true,
            specialistId: '',
            mobileApp: true,
        };
        return this.initUsers();
    }

    initUsers() {
        const promises = [];
        if (this.authService.isAdmin) {
            promises.push(this.formPatientCardioService.initCompanies());
            promises.push(
                this.formPatientCardioService.initSpecialistsFromPatient(
                    this.patient,
                ),
            );
        }
        if (this.authService.isUser) {
            promises.push(this.initCurrentCompany());
            promises.push(
                this.formPatientCardioService.initSpecialistsFromCompanyId(
                    this.patient,
                    this.authService?.getCurrentCompany(),
                ),
            );
        }
        return forkJoin(promises);
    }

    initCurrentCompany() {
        return this.companyService
            .getCompany(this.authService?.getCurrentCompany())
            .pipe(
                tap((company) => {
                    this.patient.companyId = company;
                    this.patient.inclusion.type =
                        company?.inclusionTypes?.[0] || 'commonLaw';
                    this.patient.inclusion.enableTensio =
                        company?.services?.cardio?.enableTensio;
                    if (this.authService.canBeReferent.all) {
                        this.patient.specialistId =
                            this.authService.getCurrentUser();
                    }
                }),
            );
    }

    canSavePatientFast() {
        return (
            this.patient.specialistId &&
            this.patient.medicalData.currentRate &&
            this.patient.medicalData.systolicFunction &&
            this.patient.lastName &&
            this.patient.firstName &&
            this.patient.phones.first &&
            this.patient.language &&
            this.formPatientCardioService.checkCarestaffPatient(this.patient)
        );
    }

    includedPatient() {
        const formData = this.formatService.formatPatientFast(this.patient);
        formData.append('comment', this.comment);

        return this.http
            .post<any>(`${environment.apiUrl}/patient`, formData, {
                params: {
                    disease: 'cardio',
                },
            })
            .pipe(
                catchError((err) => {
                    this.errorService.initErrors(err?.error?.errors);
                    return throwError(err);
                }),
            );
    }

    checkExistance(patient) {
        const httpParams = new HttpParams()
            .append('firstName', patient.firstName)
            .append('lastName', patient.lastName)
            .append('nir', patient.socialSecurityNumber);

        return this.http
            .get(`${environment.apiUrl}/patient`, { params: httpParams })
            .pipe(
                catchError((err) => {
                    this.errorService.initErrors(err?.error?.errors);
                    return throwError(err);
                }),
            );
    }
}
